import React, { FC, useState, useCallback, useMemo } from 'react'
import { makeStyles } from '@mui/styles'
import { TabsComponent } from '../../../components/Tabs'
import { Wallets } from './Wallets/Wallets'
import { BankAccounts } from './BankAccounts'
import { ITabList } from '../tabList'

const tabList: Array<ITabList> = [
  { tabLabel: 'Wallets', slug: 'wallets', component: Wallets },
  { tabLabel: 'Bank Accounts', slug: 'bank-accounts', component: BankAccounts },
]

const useStyles = makeStyles({
  tabs: {
    border: 'none',
  },
})

export const Accounts: FC = () => {
  const classes = useStyles()
  const [activeTab, setActiveTab] = useState('wallets')

  const handleTabChange = useCallback((key: string) => {
    setActiveTab(key)
  }, [])

  const tabClasses = useMemo(
    () => ({
      tabs: classes.tabs,
    }),
    [classes.tabs],
  )

  return <TabsComponent tabList={tabList} activeTab={activeTab} onChangeTab={handleTabChange} classes={tabClasses} />
}
